/*
 * bpmbuild-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StripeCustomerBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./StripeCustomerBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildProductionappspotcom) {
      root.BpmbuildProductionappspotcom = {};
    }
    root.BpmbuildProductionappspotcom.StripeCustomerEventObject = factory(root.BpmbuildProductionappspotcom.ApiClient, root.BpmbuildProductionappspotcom.StripeCustomerBean);
  }
}(this, function(ApiClient, StripeCustomerBean) {
  'use strict';

  /**
   * The StripeCustomerEventObject model module.
   * @module model/StripeCustomerEventObject
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>StripeCustomerEventObject</code>.
   * @alias module:model/StripeCustomerEventObject
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>StripeCustomerEventObject</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StripeCustomerEventObject} obj Optional instance to populate.
   * @return {module:model/StripeCustomerEventObject} The populated <code>StripeCustomerEventObject</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('object'))
        obj._object = StripeCustomerBean.constructFromObject(data['object']);
    }
    return obj;
  }

  /**
   * @member {module:model/StripeCustomerBean} _object
   */
  exports.prototype._object = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsProduction/src/model/StripeCustomerEventObject.js